import React from 'react';

interface PropTypes {
    message?: string;
    rowHeight?: string;
    title?: string;
    children?: React.ReactNode;
}

const MessageInfo: React.FC<PropTypes> = ({ message = 'message', rowHeight = '15vh', title, children }) => {
    return (
        <div className="card shadow bg-body rounded border-0 mt-4">
            <div className="card-body p-0 pe-5 ps-4 align-middle text-center">
                <div
                    className="row"
                    style={{ height: rowHeight, width: '100%' }}
                    data-testid="MsgInfoRowHeight"
                >
                    <div className="col-md-12" style={{ margin: 'auto', paddingTop: '10px' }}>
                        {title && <p className="align-middle m-2">{title}</p>}
                        <p className="m-2">{message}</p>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MessageInfo;
